import React from "react";

import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import "./App.scss";

import ReactModal from "react-modal";
import ReactModalStyle from "./ReactModalStyle";

import employees from "./employees";
import Graph from "./Graph";
import Sizes from "./Sizes";

import Navbar from "./Navbar";
import EmployeeList from "./EmployeeList";
import Chart from "./Chart";
import LineManagerSelector from "./LineManagerSelector";
import AddEditModal from "./AddEditModal";
import axios from 'axios';

ReactModal.setAppElement("#root");

class App extends React.Component {
  constructor(props) {
    super(props);
    Sizes.forceUpdate();
    this.state = {
      modal: "none",
      modalCb: null,
      modalData: {},
      height: Sizes.height,
      width: Sizes.width,
      selected: [],
      showLineManager: false, // else id of entity
      exportedEmployeesList: []
    };
    window.addEventListener("resize", e => {
      const height = document.body.clientHeight;
      const width = document.body.clientWidth;
      Sizes._update(width, height);
      this.setState({
        height: height,
        width: width
      });
    });
    Graph.employeeList = employees;
    Graph.registerUpdateCb(() => this.forceUpdate());
  }

  componentDidMount() {
    //https://jsonplaceholder.typicode.com/users
    //https://localhost:44362/default
    axios.get(Graph.baseURL + '/orgchart/GetEmployees?SearchValue=&CompanyID=1&PageSize=50', {
      headers: {
        'Authorization': Graph.token
      }})
    .then(res => 
      {
        this.setState({exportedEmployeesList: res.data.result});
        Graph.employeeList = res.data.result;
        
        axios.get(Graph.baseURL + '/orgchart/GetOrgChart?CompanyID=1', {
          headers: {
            'Authorization': Graph.token
          }})
        .then(res => 
        {
          Graph.graph = res.data.result;
          Graph.graphIdMapping = Graph._createGraphIdMapping(res.data.result);
          Graph.buildEmployees();
          this.setState({exportedEmployeesList: Graph.employeeList});
          Graph._updateCb();
        }
    )
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.headers);
      } 
      else if (error.request) {
          console.log(error.request);
      } 
      else {
        console.log(error.message);
      }
    console.log(error.config);
  });
    }
    )
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.headers);
      } 
      else if (error.request) {
          console.log(error.request);
      } 
      else {
        console.log(error.message);
      }
    console.log(error.config);
  });

    Sizes.forceUpdate();
    this.forceUpdate();
  }

  updateEmployees = (updatedEmployees) => this.setState({exportedEmployeesList: updatedEmployees});
  openModal = (modalType, modalData, cb) =>
    this.setState({ modal: modalType, modalCb: cb, modalData });
  closeModal = e => this.setState({ modal: "none" });

  updateSelected = selected => this.setState({ selected });

  render() {
    var updateEmployees  =   this.updateEmployees;
    const { modal, modalCb, modalData, selected, showLineManager, exportedEmployeesList } = this.state;
    return (
      <div className="App">
        
        <div className="mrow">
          <div className="mcolumn mcolumn-10">
          
            <EmployeeList
              employees={exportedEmployeesList}//exportedEmployeesList
              selected={selected}
              updateSelected={this.updateSelected}
              height={Sizes.employeeListHeight}
              updateEmployees = {updateEmployees.bind(this)}
            />
          </div>
          <div className="mcolumn mcolumn-90">
            {!showLineManager ? (
              <Chart
                employees={exportedEmployeesList}//exportedEmployeesList
                openModal={this.openModal}
                openLineManager={entityId =>
                  this.setState({ showLineManager: entityId })
                }
                height={Sizes.chartHeight}
                width={Sizes.mainWidth}
                Sizes={Sizes}
                Graph={Graph}
              />
            ) : (
              <LineManagerSelector
                Graph={Graph}
                entityId={showLineManager}
                employeeDetails={exportedEmployeesList}//exportedEmployeesList
                close={() => this.setState({ showLineManager: false })}
                height={Sizes.mainHeight}
                width={Sizes.mainWidth}
              />
            )}
          </div>
        </div>
        <ReactModal style={ReactModalStyle} isOpen={modal !== "none"}>
          <div className="clearfix">
            <h3 className="float-left">
              {modal === "add" ? "Add" : "Edit"} Entity
            </h3>
            <button className="float-right" onClick={this.closeModal}>
              &#10006;
            </button>
          </div>
          {modal && (
            <AddEditModal
              modalType={modal}
              cb={modalCb}
              modalData={modalData}
              close={this.closeModal}
              Graph={Graph}
              employeeDetails={exportedEmployeesList}//exportedEmployeesList
            />
          )}
        </ReactModal>
      </div>
    );
  }
}

function ReactDNDApp() {
  return (
    <div>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </div>
  );
}

export default ReactDNDApp;
